import { AuthModel } from "../models/auth.model"

export class AuthService {
    static saveAuth(auth: AuthModel) {
        localStorage.setItem('auth2', JSON.stringify(auth))
    }

    static hasAuth() {
        return localStorage.getItem('auth2') != null
    }

    static clearAuth() {
        localStorage.removeItem('auth2')
        // Also drop the modern wellnuo-backend session set by the /auto-login
        // WebView path. clearAuth used to remove only 'auth2', so a stale
        // `accessToken` survived logout and then SHADOWED the fresh auth2.token
        // in walksAuthHeaders() — causing 401s on /api/me/* while the rest of
        // the app worked off the good token. Clear both on logout.
        localStorage.removeItem('accessToken')
        localStorage.removeItem('userId')
    }

    static getAuth(): AuthModel {
        if (localStorage.getItem('auth2') == null)
            throw new Error('NO_AUTH')

        return JSON.parse(localStorage.getItem('auth2')!)
    }

    static updateAuth(patch: Partial<AuthModel>) {
        if (!this.hasAuth()) return
        const current = this.getAuth()
        this.saveAuth({ ...current, ...patch })
    }
}
